import { ImageWithText as ImageWithTextBase, Link, NextImage, RichTextHeading } from "@jog/react-components"
import { imageSizes } from "@jog/shared"
import { asLink, isFilled } from "@prismicio/helpers"

import { SliceProps } from "./index"

export const ImageWithText = ({
    slice: { primary },
    className,
    lcp,
}: SliceProps<"image_with_text"> & { lcp: boolean }) => {
    return (
        <ImageWithTextBase
            className={className}
            background={primary.background}
            button_text_color={primary.button_text_color}
            button_background={primary.button_background}
            button_border={primary.button_border}
            mobile_image_down={primary.mobile_image_down}
            desktop_image_right={primary.desktop_image_right}
            text_color={primary.text_color}
            imageBlock={
                isFilled.image(primary.image) ? (
                    <NextImage
                        className="w-full"
                        src={primary.image.url}
                        alt={primary.image.alt}
                        width={primary.image.dimensions.width}
                        height={primary.image.dimensions.height}
                        sizes={imageSizes({ lg: "50vw", sm: "100vw" })}
                        lcp={lcp}
                    />
                ) : (
                    <></>
                )
            }
            textBlock={
                <div className="text-black">
                    <div className="text-[var(--text-color)]">
                        <RichTextHeading field={primary.text} />
                    </div>
                    {isFilled.link(primary.button_url) && primary.button_text ? (
                        <Link
                            className="mt-10 inline-flex border border-solid border-[var(--button-border)] bg-[var(--button-background)] py-2 px-4 text-[var(--button-text-color)]"
                            href={asLink(primary.button_url)}
                            target={primary.button_url.link_type === "Web" ? primary.button_url.target : "_self"}>
                            {primary.button_text}
                        </Link>
                    ) : (
                        <></>
                    )}
                </div>
            }
        />
    )
}
